export const Languages = [
  {
    id: "swift",
    label: "Swift",
    mode: "swift",
  },
  {
    id: "c",
    label: "C",
    mode: "c_cpp",
  },
  {
    id: "cpp",
    label: "C++",
    mode: "c_cpp",
  },
  {
    id: "objective-c",
    label: "Objective-C",
    mode: "objectivec",
  },
  {
    id: "java",
    label: "Java",
    mode: "java",
  },
  {
    id: "php",
    label: "PHP",
    mode: "php",
  },
  {
    id: "ruby",
    label: "Ruby",
    mode: "ruby",
  },
  {
    id: "python",
    label: "Python2",
    mode: "python",
  },
  {
    id: "python3",
    label: "Python3",
    mode: "python",
  },
  {
    id: "perl",
    label: "Perl",
    mode: "perl",
  },
  {
    id: "kotlin",
    label: "Kotlin",
    mode: "kotlin",
  },
  {
    id: "scala",
    label: "Scala",
    mode: "scala",
  },
  {
    id: "go",
    label: "Go",
    mode: "golang",
  },
  {
    id: "csharp",
    label: "C#",
    mode: "csharp",
  },
  {
    id: "haskell",
    label: "Haskell",
    mode: "haskell",
  },
  {
    id: "clojure",
    label: "Clojure",
    mode: "clojure",
  },
  {
    id: "d",
    label: "D",
    mode: "d",
  },
  {
    id: "erlang",
    label: "Erlang",
    mode: "erlang",
  },
  {
    id: "r",
    label: "R",
    mode: "r",
  },
  {
    id: "javascript",
    label: "JavaScript",
    mode: "javascript",
  },
  {
    id: "coffeescript",
    label: "CoffeeScript",
    mode: "coffee",
  },
  {
    id: "typescript",
    label: "TypeScript",
    mode: "typescript",
  },
  {
    id: "cobol",
    label: "Cobol",
    mode: "cobol",
  },
  {
    id: "vb",
    label: "VB",
    mode: "vbscript",
  },
  {
    id: "fsharp",
    label: "F#",
    mode: "fsharp",
  },
  {
    id: "bash",
    label: "Bash",
    mode: "sh",
  },
  {
    id: "elixir",
    label: "Elixir",
    mode: "elixir",
  },
  {
    id: "rust",
    label: "Rust",
    mode: "rust",
  },
  {
    id: "scheme",
    label: "Scheme",
    mode: "scheme",
  },
  {
    id: "nadesiko",
    label: "Nadesiko",
    mode: "text",
  },
  {
    id: "mysql",
    label: "MySQL",
    mode: "mysql",
  },
];
